import React from 'react'
import LineSeparator from '../../../../../packages/kiti/components/helpers/LineSeparator'
import { COLORS } from '@btime/constants'
import Separator from '../../../../../components/pdf/Separator'
import { MONTHS } from '../../constants/dates'
import { findReplyByQuestionId, getReplyValue } from '../../_helpers/pdfHelpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { Grid } from '../../../../../packages/kiti/components/structure/Grid'
import Image from '../../../../../components/pdf/Image'
import View from '../../../../../components/pdf/View'
import { BODY_ORIGIN_ID, useEasySolutionsPageNumbers } from '../../_shared/pagination'

const Content = () => {
  const { replies, endDate } = useServiceOrder()
  const question359 = findReplyByQuestionId(replies, 359)
  const question363 = findReplyByQuestionId(replies, 363)
  const question365 = findReplyByQuestionId(replies, 365)
  const question366 = findReplyByQuestionId(replies, 366)
  const question367 = findReplyByQuestionId(replies, 367)
  const question368 = findReplyByQuestionId(replies, 368)
  const question370 = findReplyByQuestionId(replies, 370)
  const question373 = findReplyByQuestionId(replies, 373)
  const question375 = findReplyByQuestionId(replies, 375)
  const question379 = findReplyByQuestionId(replies, 379)
  const question380 = findReplyByQuestionId(replies, 380)
  const question381 = findReplyByQuestionId(replies, 381)
  const question383 = findReplyByQuestionId(replies, 383)
  const question384 = findReplyByQuestionId(replies, 384)
  const question385 = findReplyByQuestionId(replies, 385)
  const question386 = findReplyByQuestionId(replies, 386)
  const question387 = findReplyByQuestionId(replies, 387)

  const currentMonth = new Date(endDate).getMonth()
  const currentYear = new Date(endDate).getFullYear()

  const chunkArray = (arr, size) => {
    const result = []
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size))
    }
    return result
  }

  const renderImages = documents => {
    if (!documents) return null
    const groups = chunkArray(documents, 3)

    return groups.map((group, idx) => (
      <div
        key={idx}
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '16px',
          marginTop: '15px',
          flexWrap: 'wrap'
        }}
      >
        {group.map(doc => (
          <div
            key={doc.src}
            style={{
              textAlign: 'center',
              maxWidth: '220px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              backgroundColor: '#fff'
            }}
          >
            <Image
              src={doc.src}
              style={{
                height: '200px',
                width: '100%',
                objectFit: 'cover'
              }}
            />
            {doc?.description && (
              <div
                style={{
                  padding: '8px',
                  fontSize: '12pt',
                  textAlign: 'justify',
                  marginLeft: 0,
                  marginRight: 0,
                  textIndent: '1.25cm',
                  marginTop: 0,
                  marginBottom: '8pt',
                  lineHeight: 1.16,
                  borderTop: '1px solid #eee',
                  background: '#fafafa'
                }}
              >
                {doc.description}
              </div>
            )}
          </div>
        ))}
      </div>
    ))
  }

  const renderQuestion = question => {
    if (!question?.question?.name) return null

    const isArray = Array.isArray(question?.value)
    const displayValue = isArray
      ? ''
      : typeof question?.value === 'boolean'
      ? question.value
        ? 'Sim'
        : 'Não'
      : question?.value ?? 'N/A'

    const files = (isArray ? question?.value : question?.documents) ?? []

    return (
      <section>
        {/* Gap 1 (PR #761 seguimento, pedido da Julia Buzzo): este <p> compartilhado por
            renderQuestion() é usado em ~17 pontos deste template (seções 3, 5, 6, 7, 8) e
            só tinha recebido o textAlign:'justify' da 1ª rodada de #761 — faltava o resto
            do espaçamento de parágrafo (recuo de 1ª linha, margens, line-height) aplicado
            aos demais parágrafos do documento na 2ª rodada. fontFamily não é repetido aqui
            de propósito: herda de 'Arial, sans-serif' do <div> raiz (linha ~158), mesmo
            padrão dos outros parágrafos já corrigidos neste arquivo (ex.: pergunta 368). */}
        <p
          style={{
            textAlign: 'justify',
            marginLeft: 0,
            marginRight: 0,
            textIndent: '1.25cm',
            marginTop: 0,
            marginBottom: '8pt',
            lineHeight: 1.16
          }}
        >
          <strong>{question?.question?.name}:</strong> {displayValue}
        </p>

        {files.length > 0 && (
          <Grid wrap gap={0.5} align="center" justify="center">
            {renderImages(files)}
          </Grid>
        )}
      </section>
    )
  }

  // Gap 4 (pedido da Julia Buzzo): sem fontWeight:'bold' forçado — o Sumário é uma lista de
  // links com "leaders" de número de página, não corpo de texto corrido, então mantemos
  // peso normal (herdando Arial 12pt do <div> raiz) e SEM o tratamento de justify/recuo de
  // 1ª linha usado no corpo do documento.
  const linkStyle = {
    color: 'black',
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '7.5px'
  }

  // Causa raiz do Sumário com números errados (reportado pela Julia Buzzo): o PR #779
  // envolveu cada título de seção (exceto "1. Introdução") com `<View pageBreakBefore>`,
  // que sempre empurra a seção para o topo de uma página nova — mas os números abaixo
  // continuaram cravados nos valores de antes daquele PR, e o conteúdo de cada seção
  // (nº de perguntas respondidas, nº de fotos anexadas, ver `renderQuestion`/
  // `renderImages` acima) varia por Atividade, então nenhum número fixo se mantém certo.
  // `page` não é mais digitado à mão: vem de `useEasySolutionsPageNumbers`
  // (`_shared/pagination.js`), que mede a posição real de cada âncora já renderizada —
  // mesma técnica já usada em `pdfs/bradesco/pgr/_helpers/pagination.js`.
  //
  // Duas âncoras também estavam quebradas (bug separado do de página, mas na mesma lista,
  // e precisava ser corrigido de qualquer forma para o motor de paginação conseguir medir
  // a posição real de cada item — não dá pra medir uma âncora que não existe/não bate):
  // "tensão-central" (com acento) nunca bateu com o `id="tensao-central-incendio"` real do
  // `<h3>` da seção 4 abaixo (link morto no PDF), e a seção 5 "Teste do Sistema" não tinha
  // `id` nenhum no seu `<h3>` (corrigido abaixo, ver `id="teste-do-sistema"`).
  const summaryItems = [
    { id: 'introducao', title: '1. Introdução' },
    { id: 'ferramentas-utilizadas', title: '2. Ferramentas Utilizadas para Testar Detectores' },
    { id: 'servicos-realizados', title: '3. Serviços Realizados' },
    { id: 'tensao-central-incendio', title: '4. Tensão da Central de Incêndio' },
    { id: 'teste-do-sistema', title: '5. Teste do Sistema' },
    { id: 'status-sistema-supressao-co2', title: '6. Status do Sistema de Supressão de CO2 ao Sair' },
    { id: 'melhoria-sistema', title: '7. Melhoria no Sistema' },
    { id: 'conclusao', title: '8. Conclusão' }
  ]

  // Ordem de documento das âncoras com `pageBreakBefore` (todas, exceto "introducao", que
  // já começa no topo da página por causa do `pageBreakAfter` do Sumário) — necessária
  // para o motor de paginação calcular o deslocamento acumulado corretamente.
  const forcedBreakAnchorIds = [
    'ferramentas-utilizadas',
    'servicos-realizados',
    'tensao-central-incendio',
    'teste-do-sistema',
    'status-sistema-supressao-co2',
    'melhoria-sistema',
    'conclusao'
  ]
  const pageNumbers = useEasySolutionsPageNumbers(
    summaryItems.map(item => item.id),
    forcedBreakAnchorIds
  )

  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        fontSize: '12pt',
        textAlign: 'justify',
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: '8pt',
        lineHeight: 1.16
      }}
    >
      {/* Gap 5 (pedido da Julia Buzzo, ver PR): capa isolada em pagina propria com
          <View pageBreakAfter> (mesma convencao de page-break CSS ja usada em
          pdfs/bradesco/pgr, ver components/pdf/View.js / 00.CoverSection.js), em vez de
          depender so da contagem de <br/> para empurrar o conteudo seguinte para a
          proxima pagina. Isso corrige a causa raiz do espaco em branco grande antes do
          "Sumario" relatado pela Julia: com @page { margin: 3cm 2cm 2cm 3cm } (round 3
          de #761) a area util da pagina encolheu, e a contagem antiga de <br/> (calibrada
          para as margens anteriores) passou a sobrar/faltar. Com o page-break explicito,
          o bloco seguinte SEMPRE comeca no topo da proxima pagina, independente da
          contagem de <br/> usada aqui so para espacamento vertical dentro da propria
          pagina -- essa contagem residual foi removida no seguimento abaixo apos causar overflow de pagina. */}
      <View pageBreakAfter>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br /> <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <h2 style={{ textAlign: 'center' }}>
          SABIC CENTRAL CO2 RESINAS <br />
          <br />
          MANUTENÇÃO PREVENTIVA SUPRESSÃO POR CO2 <br />
          <br />
          {MONTHS[currentMonth]?.toUpperCase()} - {currentYear}
        </h2>
      {/* Seguimento (2º report da Julia Buzzo, mesmo PR): removida a contagem residual
          de <br/> que ficava aqui como "estimativa conservadora" pos-#761. Combinada
          com o pageBreakAfter, ela empurrava o conteudo alem de uma pagina inteira e
          transbordava para uma pagina extra quase em branco antes da quebra forcada
          entrar em acao -- essa era a causa das paginas em branco no meio do
          documento. O pageBreakAfter sozinho ja garante que o proximo bloco comece
          no topo da proxima pagina; nenhum <br/> de preenchimento e necessario aqui. */}
      </View>
      <View pageBreakAfter>
        <LineSeparator weight={4} color={COLORS.light3} padding={4} />
        <h2>
          Sumário
        </h2>
        <br />
        <br />
        <br />
        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
          {summaryItems.map(item => (
            <li key={item.id}>
              <a href={`#${item.id}`} style={linkStyle}>
                <span>{item.title}</span>
                <span style={{ flex: 1, margin: '0 10px', borderBottom: '2px dotted #000', lineHeight: 0 }} />
                <span>{pageNumbers[item.id] ?? ''}</span>
              </a>

              {item.children?.map(child => (
                <a key={child.id} href={`#${child.id}`} style={linkStyle}>
                  <span style={{ textIndent: '10px' }}>{child.title}</span>
                  <span style={{ flex: 1, margin: '0 10px', borderBottom: '2px dotted #000', lineHeight: 0 }} />
                  <span>{pageNumbers[child.id] ?? ''}</span>
                </a>
              ))}
            </li>
          ))}
        </ul>
        {/* Seguimento (2º report da Julia Buzzo): mesma remocao do bloco de capa acima --
            a contagem residual de <br/> aqui transbordava a pagina do Sumario e, com o
            pageBreakAfter, gerava uma pagina extra quase em branco antes da Introducao.
            O pageBreakAfter ja garante que o proximo bloco comece na pagina certa. */}
      </View>
      {/* Âncora "zero" do motor de paginação do Sumário (ver `_shared/pagination.js`):
          marca o topo do conteúdo do corpo, que sempre começa na página 3 por causa do
          `pageBreakAfter` do Sumário logo acima. */}
      <div id={BODY_ORIGIN_ID} />
      <LineSeparator weight={4} color={COLORS.light3} padding={4} />
      <h3 id="introducao">1. Introdução</h3>
      {/* Gap 3: normalizado de textIndent:'2em' para '1.25cm' + resto do espaçamento de
          parágrafo, igual ao usado no restante do documento (ex.: renderQuestion acima). */}
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >
        Este Relatório tem como objetivo expressar as atividades realizadas pela empresa Easy Solutions, bem como
        substituição de dispositivos danificados, visando informar sempre as melhorias cabíveis ao sistema de acordo com
        a necessidade de cada cliente e atender a NBR 17240-2010 (Sistema de Detecção e Alarme de Incêndio, Projetos,
        Instalações e Manutenções do Sistema).
      </p>
      <View pageBreakBefore>
        <h3 id="ferramentas-utilizadas">2. Ferramentas utilizadas para Testar Detectores</h3>
      </View>
      {/* Gap 3: normalizado de textIndent:'2em' para '1.25cm' + resto do espaçamento de
          parágrafo, igual ao usado no restante do documento (ex.: renderQuestion acima). */}
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >
        A Easy Solutions possui o Kit para testar Detectores Térmico, utilizam Soprador Térmico, equipamentos que
        atendem as Normas Internacionais de Fire Alarm NBR-17240-2010, conforme figura abaixo.
      </p>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Image
          src="/pdfs/easysolutions/soprador_termico2.png"
          maxHeight={'175px'}
          ignoreFixedSize
          alt="Figura 1 Alarme de Incendio"
        />
      </div>
      <View pageBreakBefore>
        <h3 id="servicos-realizados">3. Serviços Realizados</h3>
      </View>
      {renderQuestion(question359)}
      {renderQuestion(question363)}
      {renderQuestion(question365)}
      {renderQuestion(question366)}
      {renderQuestion(question367)}
      <View pageBreakBefore>
        <h3 id="tensao-central-incendio">4. Tensão da Central de Incêndio</h3>
      </View>
      <section>
        <p>
          <strong>{question368?.question?.name}:</strong>{' '}
          <p
            style={{
              textAlign: 'justify',
              marginLeft: 0,
              marginRight: 0,
              textIndent: '1.25cm',
              marginTop: 0,
              marginBottom: '8pt',
              lineHeight: 1.16
            }}
          >
            {question368?.value?.split('\n').map((line, idx) => (
              <React.Fragment key={idx}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </p>

        <Grid wrap gap={0.5} align="center" justify="center">
          {renderImages(question368?.documents)}
        </Grid>
      </section>
      <View pageBreakBefore>
        {/* `id="teste-do-sistema"` (faltava): sem ele o link/âncora do Sumário para esta
            seção era morto (apontava para um `#teste-do-sistema` inexistente) e o motor de
            paginação não conseguia medir a posição real desta seção. */}
        <h3 id="teste-do-sistema">5. Teste do Sistema</h3>
      </View>
      {renderQuestion(question373)}
      {renderQuestion(question375)}
      {renderQuestion(question379)}
      {renderQuestion(question380)}
      {renderQuestion(question370)}
      {renderQuestion(question373)}
      {renderQuestion(question375)}
      <View pageBreakBefore>
        <h3 id="status-sistema-supressao-co2">6. Status do sistema de supressão por CO2 ao sair</h3>
      </View>
      {renderQuestion(question381)}
      {renderQuestion(question383)}
      {renderQuestion(question384)}
      {renderQuestion(question385)}
      <View pageBreakBefore>
        <h3 id="melhoria-sistema">7. Melhoria no sistema</h3>
      </View>
      {renderQuestion(question386)}
      <View pageBreakBefore>
        <h3 id="conclusao">8. Conclusão</h3>
      </View>
      {renderQuestion(question387)}
      <Separator weight={5} />
    </div>
  )
}

export default Content
